import { render, staticRenderFns } from "./PrioritaColors.vue?vue&type=template&id=3379bd68"
import script from "./PrioritaColors.vue?vue&type=script&lang=js"
export * from "./PrioritaColors.vue?vue&type=script&lang=js"
import style0 from "./PrioritaColors.vue?vue&type=style&index=0&id=3379bd68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports